import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { filter, find, reduce, concat, first, map, difference, intersection, orderBy } from 'lodash';
import { Dropdown, MenuItem } from 'react-bootstrap';
import moment from 'moment';

// import { getAvailableContacts } from '../../WinLossReducer';

import { getTablePreference } from '../../../App/AppReducer';

import GodTable, { CUSTOM_FIELD_TYPES } from '../../../../components/god-table';
import { dateComparator, minDateAggregation, stringComparator } from '../../../../components/table-cells/helpers';
import AccountNameRenderer from '../../../../components/table-cells/AccountNameRenderer';
import OpportunityNameRenderer from '../../../../components/table-cells/OpportunityNameRenderer';
import LogRenderer from '../../../../components/table-cells/LogRenderer';
import SaleRepsNameRenderer from '../../../../components/table-cells/SaleRepsNameRenderer';
import StatusRenderer from './StatusRenderer';
import CheckboxRenderer, { ALL_SUBMIT, PARTIAL_SUBMIT, NONE_SUBMIT } from './CheckboxRenderer';
import CheckboxHeaderRenderer from './CheckboxHeaderRenderer';
import ActionRenderer from './ActionRenderer';
import ContactRenderer from './ContactRenderer';
import WarningRenderer from './WarningRenderer';
import LoadingRenderer from './LoadingRenderer';
import LogModal from '../log-modal';

import styles from './styles.css';

const FILTER_OPTIONS = [
  { value: null, label: 'All Opportunities' },
  { value: 'submitted', label: 'Submitted Opportunities' },
  { value: 'unsubmitted', label: 'Not Submitted Opportunities' },
];

const STATUS_COLUMN_ID = '__STATUS__';

class OpportunityTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: null, // null, submitted, unsubmitted
      groupingByCloseDate: false,
      closeDateGroupingType: 'monthly',
      dynamicColumnIds: [],
      loggedOpportunity: null,
    };

    this.handleToggleAll = this.handleToggleAll.bind(this);

    this.showDispositionsDetail = this.showDispositionsDetail.bind(this);

    this.handleOnColumnRowGroupChanged = this.handleOnColumnRowGroupChanged.bind(this);
    this.getMainMenuItems = this.getMainMenuItems.bind(this);
    this.onGridReady = this.onGridReady.bind(this);
    this.handleCellClicked = this.handleCellClicked.bind(this);
    this.checkboxValueGetter = this.checkboxValueGetter.bind(this);
    this.productColumnValueGetter = this.productColumnValueGetter.bind(this);
    this.contactColumnValueGetter = this.contactColumnValueGetter.bind(this);
    this.handleProductCellClicked = this.handleProductCellClicked.bind(this);
    this.handleContactCellClicked = this.handleContactCellClicked.bind(this);
    this.handleRequestSelectOpportunity = this.handleRequestSelectOpportunity.bind(this);
    this.handleRequestDeselectOpportunity = this.handleRequestDeselectOpportunity.bind(this);
    this.handleFilterSelect = this.handleFilterSelect.bind(this);
    this.handleRequestShowLogs = this.handleRequestShowLogs.bind(this);
    this.getRowClass = this.getRowClass.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const current = this.props.editingOpportunity || {};
    const next = nextProps.editingOpportunity || {};
    const currentCount = this.props.countSelected;
    const nextCount = nextProps.countSelected;
    if (current.opportunity_id !== next.opportunity_id && !next.opportunity_id) {
      this.refresh();
    } else if (currentCount !== nextCount) {
      if (this.gridApi) {
        this.gridApi.redrawRows({ force: true });
      }
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  onGridReady(params) {
    const { tableColumns } = this.props;
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.addAggFunc('minDate', minDateAggregation);
    const validColumns = filter(tableColumns, col => col.tag === 'products' || col.tag === 'contacts');
    const defaultColumns = [STATUS_COLUMN_ID, 'action', 'checkbox', 'product-selected', 'product-available', 'contact-selected', 'contact-submitted'];
    const dynamicColumnIds = concat(map(validColumns, '_id'), defaultColumns);
    this.setState({ dynamicColumnIds });
  }

  getRowClass(params) {
    const r = this.productColumnValueGetter(params);
    const r2 = this.contactColumnValueGetter(params);
    if (r && r.loaded) {
      if (r.allSubmitted) {
        return styles.disabledRow;
      }
      if (r.isSelected) {
        if (r.selectedProductCount > 0 && r2.selectedContactCount > 0) {
          return styles.selectedRow;
        }
        return styles.errorRow;
      }
    }
    return null;
  }

  getMainMenuItems(params) {
    const { groupingByCloseDate, closeDateGroupingType } = this.state;
    const columnId = params.column.getId();
    if (groupingByCloseDate && columnId === 'ag-Grid-AutoColumn') {
      const menuItems = params.defaultItems.slice(0);
      const subMenus = [
        { name: 'Monthly', value: 'monthly' },
        { name: 'Quarterly', value: 'quarterly' },
        { name: 'Yearly', value: 'yearly' },
      ];
      menuItems.push({
        name: 'Group By Close Date',
        checked: groupingByCloseDate,
        subMenu: subMenus.map(item => ({
          ...item,
          checked: item.value === closeDateGroupingType,
          action: () => {
            this.setState(
              { closeDateGroupingType: item.value },
              () => {
                if (this.gridApi) {
                  this.gridApi.refreshClientSideRowModel('group');
                }
              },
            );
          },
        })),
      });
      return menuItems;
    }
    return params.defaultItems;
  }

  getAccountColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      cellClass: column.auto_height ? 'cell-wrap-text' : null,
      autoHeight: column.auto_height,
      enablePivot: true,
      enableRowGroup: true,
      field: 'account.name',
      comparator: stringComparator,
      cellRendererSelector: (params) => {
        if (!params) {
          return null;
        }
        return {
          component: 'accountNameRenderer',
          params: {
            enableAutoHeight: true,
            column,
            exportURLType: 'account',
          },
        };
      },
    };
  }

  getNameColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'name',
      cellClass: column.auto_height ? 'cell-wrap-text' : null,
      autoHeight: column.auto_height,
      comparator: stringComparator,
      cellRenderer: 'opportunityNameRenderer',
      cellRendererParams: {
        enableAutoHeight: true,
        exportURLType: 'opportunity',
        column: {
          ...column,
        },
      },
    };
  }

  getAmountColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'amount',
      type: 'numericColumn',
      cellRenderer: 'logRenderer',
      cellRendererParams: {
        field: 'amount',
        column,
      },
      enableValue: true,
      allowedAggFuncs: ['sum', 'min', 'max', 'avg'],
    };
  }

  getCloseDateColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'close_date',
      sort: 'desc',
      type: 'dateColumn',
      onCellClicked: this.handleCellClicked,
      cellRendererSelector: (params) => {
        if (!params) {
          return null;
        }
        return {
          component: 'logRenderer',
          params: {
            field: 'close_date',
          },
        };
      },
      enableRowGroup: true,
      cellRendererParams: {
        isCloseDate: true,
        column,
      },
      valueGetter: (params) => {
        if (params && params.data) {
          return moment(params.data.close_date).format('YYYY-MM-DD');
        }
        return null;
      },
      keyCreator: (params) => {
        const vals = params.value;
        if (!vals) {
          return '--';
        }
        let format = 'Y \\QQ';
        if (this.state.closeDateGroupingType === 'quarterly') {
          format = 'Y \\QQ';
        } else if (this.state.closeDateGroupingType === 'monthly') {
          format = 'Y MM';
        } else if (this.state.closeDateGroupingType === 'yearly') {
          format = 'Y';
        }
        return moment(vals, 'YYYY-MM-DD').format(format);
      },
      valueFormatter: (params) => {
        if (params.value) {
          let format = 'Y \\QQ';
          let displayFormat = '\\QQ Y';
          if (this.state.closeDateGroupingType === 'quarterly') {
            format = 'Y \\QQ';
            displayFormat = '\\QQ Y';
          } else if (this.state.closeDateGroupingType === 'monthly') {
            format = 'Y MM';
            displayFormat = 'MMMM Y';
          } else if (this.state.closeDateGroupingType === 'yearly') {
            format = 'Y';
            displayFormat = 'Y';
          }
          return moment(`${params.value}`, format).format(displayFormat);
        }
        return params.value;
      },
    };
  }

  getStageColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'stage',
      enablePivot: true,
      enableRowGroup: true,
      onCellClicked: this.handleCellClicked,
      cellClass: column.auto_height ? 'cell-wrap-text' : null,
      autoHeight: column.auto_height,
      cellRendererParams: {
        enableAutoHeight: true,
        column,
      },
      cellRendererSelector: (params) => {
        if (!params) {
          return null;
        }
        return {
          component: 'logRenderer',
          params: {
            field: 'stage',
            logField: 'stage_name',
          },
        };
      },
    };
  }

  getOwnerColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      cellClass: column.auto_height ? 'cell-wrap-text' : null,
      autoHeight: column.auto_height,
      enablePivot: true,
      enableRowGroup: true,
      field: 'owner.name',
      cellRendererSelector: (params) => {
        if (!params) {
          return null;
        }
        return {
          component: 'saleRepsNameRenderer',
          params: {
            enableAutoHeight: true,
            column,
          },
        };
      },
    };
  }

  getStatusColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      cellRendererSelector: (params) => {
        if (!params) {
          return null;
        }
        return {
          component: 'statusRenderer',
          params: {
            showDispositionsDetail: this.showDispositionsDetail,
          },
        };
      },
      cellRendererParams: {
        column,
      },
      valueGetter: (params) => {
        if (params && params.data) {
          const { tracking } = params.data;
          const loaded = tracking !== undefined;
          if (!loaded) {
            return null;
          }
          if (tracking.submitted) {
            const hasRejected = tracking.rejectedContactIds && tracking.rejectedContactIds.length > 0;
            if (tracking.lastActivity) {
              return tracking.lastActivity.dispositionName;
            }
            if (hasRejected) {
              return 'Rejected';
            }
            return 'Pending';
          }
          return 'Not submitted';
        }
        return null;
      },
    };
  }

  getCheckColumn() {
    const { disabled, masterCheckboxStatus } = this.props;
    return {
      colId: 'checkbox',
      headerName: '',
      pinned: 'left',
      width: 35,
      field: 'opportunity_id',
      resizable: false,
      sortable: false,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      suppressMovable: true,
      suppressMenu: true,
      lockPosition: true,
      headerComponent: 'checkboxHeaderRenderer',
      onCellClicked: this.handleCellClicked,
      headerComponentParams: {
        menuIcon: 'test',
        disabled,
        status: masterCheckboxStatus,
        requestToggleAll: this.handleToggleAll,
      },
      cellRendererParams: {
      },
      cellRendererSelector: (params) => {
        if (!params || !params.data) {
          return null;
        }
        const { winLoss } = this.props;
        const selectedOpportunity = winLoss[params.data.opportunity_id];
        const isSelected = selectedOpportunity !== undefined && selectedOpportunity !== null;
        let isValid = false;
        if (isSelected) {
          const r1 = this.productColumnValueGetter(params);
          const r2 = this.contactColumnValueGetter(params);
          if (r1 && r1.loaded) {
            isValid = (r1.selectedProductCount > 0 && r2.selectedContactCount > 0);
          }
        }
        return {
          component: 'checkboxRenderer',
          params: {
            disabled,
            isSelected,
            isValid,
          },
        };
      },
      valueGetter: this.checkboxValueGetter,
    };
  }

  getActionColumn() {
    const { disabled } = this.props;
    return {
      colId: 'action',
      headerName: 'Action',
      pinned: 'right',
      width: 130,
      field: 'opportunity_id',
      resizable: false,
      sortable: false,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      suppressMovable: true,
      suppressMenu: true,
      lockPosition: true,
      cellRendererSelector: (params) => {
        if (!params || !params.data) {
          return null;
        }
        const { winLoss } = this.props;
        const selectedObject = winLoss[params.data.opportunity_id];
        return {
          component: 'actionRenderer',
          params: {
            disabled,
            isSelected: selectedObject !== undefined && selectedObject !== null,
            selectedObject,
            requestEdit: this.props.requestEditOpportunity,
            requestSelect: this.handleRequestSelectOpportunity,
            requestDeselect: this.handleRequestDeselectOpportunity,
            requestShowLogs: this.handleRequestShowLogs,
          },
        };
      },
    };
  }

  getProductColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      // width: column.width,
      hide: !column.is_visible,
      marryChildren: true,
      resizable: false,
      headerClass: 'text-center',
      cellRendererParams: {
        column,
      },
      children: [
        {
          colId: 'product-selected',
          headerName: 'Selected',
          type: 'numericColumn',
          resizable: false,
          // suppressMovable: true,
          suppressMenu: true,
          cellRendererParams: {
            column: {
              id: `${column._id}-select`,
              description: 'Count of opportunity products currently selected for submission to TruVoice',
            },
          },
          width: 105,
          onCellClicked: this.handleProductCellClicked,
          valueGetter: (params) => {
            const r = this.productColumnValueGetter(params);
            if (r && r.loaded && !r.allSubmitted && r.isSelected) {
              return r.selectedProductCount;
            }
            return null;
          },
          cellClass: (params) => {
            const r = this.productColumnValueGetter(params);
            if (r && r.loaded && !r.allSubmitted && r.isSelected) {
              const cls = [styles.cellCursor, 'text-right'];
              if (r.selectedProductCount === 0) {
                cls.push('text-danger');
              } else {
                cls.push('text-active');
              }
              return cls.join(' ');
            }
            return null;
          },
          cellRendererSelector: (params) => {
            const r = this.productColumnValueGetter(params);
            if (r && !r.loaded) {
              return {
                component: 'loadingRenderer',
              };
            }
            if (r && r.loaded && !r.allSubmitted && r.isSelected && r.selectedProductCount === 0) {
              return {
                component: 'warningRenderer',
                params: {
                  tooltip: 'Select the primary product to gather feedback on to submit this opportunity to TruVoice.',
                },
              };
            }
            return null;
          },
        },
        {
          colId: 'product-available',
          headerName: 'Available',
          type: 'numericColumn',
          resizable: false,
          // suppressMovable: true,
          suppressMenu: true,
          onCellClicked: this.handleCellClicked,
          cellRendererParams: {
            column: {
              id: `${column._id}-available`,
              description: 'Count of opportunity products that have NOT been submitted or selected',
            },
          },
          width: 110,
          valueGetter: (params) => {
            const r = this.productColumnValueGetter(params);
            if (r && r.loaded && !r.allSubmitted) {
              return r.availableProductCount;
            }
            return null;
          },
          cellRendererSelector: (params) => {
            const r = this.productColumnValueGetter(params);
            if (r && !r.loaded) {
              return {
                component: 'loadingRenderer',
              };
            }
            return null;
          },
        },
      ],
    };
  }

  getContactColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      // width: column.width,
      hide: !column.is_visible,
      marryChildren: true,
      resizable: false,
      headerClass: 'text-center',
      cellRendererParams: {
        column,
      },
      children: [
        {
          colId: 'contact-selected',
          headerName: 'Selected',
          type: 'numericColumn',
          resizable: false,
          suppressMenu: true,
          cellRendererParams: {
            column: {
              id: `${column._id}-select`,
              description: 'Count of buyers currently selected for submission to TruVoice',
            },
          },
          width: 105,
          onCellClicked: this.handleContactCellClicked,
          valueGetter: (params) => {
            const r = this.contactColumnValueGetter(params);
            if (r && r.loaded && r.canSubmitMore && r.isSelected) {
              return r.selectedContactCount;
            }
            return null;
          },
          cellClass: (params) => {
            const r = this.contactColumnValueGetter(params);
            if (r && r.loaded && r.canSubmitMore && r.isSelected) {
              const cls = [styles.cellCursor, 'text-right'];
              if (r.selectedContactCount === 0) {
                cls.push('text-danger');
              } else {
                cls.push('text-active');
              }
              return cls.join(' ');
            }
            if (r && r.loaded && !r.canSubmitMore) {
              return styles.disabledCell;
            }
            return 'text-right';
          },
          cellRendererSelector: (params) => {
            const r = this.contactColumnValueGetter(params);
            if (r && !r.loaded) {
              return {
                component: 'loadingRenderer',
              };
            }
            if (r && r.loaded && r.canSubmitMore && r.isSelected && r.selectedContactCount === 0) {
              return {
                component: 'warningRenderer',
                params: {
                  tooltip: 'Select one or more contacts to submit this opportunity to TruVoice.',
                },
              };
            }
            return null;
          },
        },
        /*
        {
          colId: 'contact-opportunity',
          headerName: 'Opportunity',
          type: 'numericColumn',
          resizable: false,
          suppressMenu: true,
          onCellClicked: this.handleCellClicked,
          cellRendererParams: {
            column: {
              id: `${column._id}-opportunity`,
              description: 'Count of opportunity buyers that have NOT been submitted or selected',
            },
          },
          width: 115,
          valueGetter: (params) => {
            const r = this.contactColumnValueGetter(params);
            if (r && r.loaded && r.canSubmitMore) {
              return r.opportunityContactCount;
            }
            return null;
          },
          cellRendererSelector: (params) => {
            const r = this.contactColumnValueGetter(params);
            if (r && !r.loaded) {
              return {
                component: 'loadingRenderer',
              };
            }
            return null;
          },
          cellClass: (params) => {
            const r = this.contactColumnValueGetter(params);
            if (r && r.loaded && !r.canSubmitMore) {
              return styles.disabledCell;
            }
            return 'text-right';
          },
        },
        {
          colId: 'contact-account',
          headerName: 'Account',
          type: 'numericColumn',
          resizable: false,
          suppressMenu: true,
          onCellClicked: this.handleCellClicked,
          cellRendererParams: {
            column: {
              id: `${column._id}-account`,
              description: 'Count of account buyers that have NOT been submitted or selected',
            },
          },
          width: 100,
          valueGetter: (params) => {
            const r = this.contactColumnValueGetter(params);
            if (r && r.loaded && r.canSubmitMore) {
              return r.accountContactCount;
            }
            return null;
          },
          cellClass: (params) => {
            const r = this.contactColumnValueGetter(params);
            if (r && r.loaded && !r.canSubmitMore) {
              return styles.disabledCell;
            }
            return 'text-right';
          },
          cellRendererSelector: (params) => {
            const r = this.contactColumnValueGetter(params);
            if (r && !r.loaded) {
              return {
                component: 'loadingRenderer',
              };
            }
            return null;
          },
        },
        */
        {
          colId: 'contact-submitted',
          headerName: 'Submitted',
          type: 'numericColumn',
          resizable: false,
          suppressMenu: true,
          onCellClicked: this.handleCellClicked,
          cellRendererParams: {
            column: {
              id: `${column._id}-submitted`,
              description: 'Count of contacts previously submitted to TruVoice for this opportunity',
            },
          },
          width: 115,
          valueGetter: (params) => {
            const r = this.contactColumnValueGetter(params);
            if (r && r.loaded) {
              return r.submittedContactCount;
            }
            return null;
          },
          cellClass: (params) => {
            const r = this.contactColumnValueGetter(params);
            if (r && r.loaded && !r.canSubmitMore) {
              return `${styles.disabledCell} text-right`;
            }
            return 'text-right';
          },
          cellRendererSelector: (params) => {
            const r = this.contactColumnValueGetter(params);
            if (r && !r.loaded) {
              return {
                component: 'loadingRenderer',
              };
            }
            return null;
          },
        },
      ],
    };
  }

  getSubmittedStatusColumn() {
    return {
      colId: STATUS_COLUMN_ID,
      headerName: '',
      width: 0,
      hide: true,
      field: 'submitted',
      resizable: false,
      suppressMenu: true,
      suppressMovable: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
      cellRendererParams: {
        column: {},
      },
    };
  }

  getRequestedFeedbackColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: column.target_field,
      cellRenderer: 'requestedFeedbackRenderer',
      cellRendererParams: {
        column,
      },
    };
  }

  getColDefs() {
    const { tableColumns } = this.props;
    const allColumns = reduce(orderBy(tableColumns, ['position'], ['asc']), (columns, tableColumn) => {
      let column = null;
      if (tableColumn.tag === 'account') {
        column = this.getAccountColumn(tableColumn);
      } else if (tableColumn.tag === 'name') {
        column = this.getNameColumn(tableColumn);
      } else if (tableColumn.tag === 'amount') {
        column = this.getAmountColumn(tableColumn);
      } else if (tableColumn.tag === 'closeDate') {
        column = this.getCloseDateColumn(tableColumn);
      } else if (tableColumn.tag === 'stage') {
        column = this.getStageColumn(tableColumn);
      } else if (tableColumn.tag === 'owner' || (tableColumn.target_object === 'Opportunity' && tableColumn.target_field === 'owner_id')) {
        column = this.getOwnerColumn(tableColumn);
      } else if (tableColumn.tag === 'status') {
        column = this.getStatusColumn(tableColumn);
      } else if (tableColumn.tag === 'products') {
        column = this.getProductColumn(tableColumn);
      } else if (tableColumn.tag === 'contacts') {
        column = this.getContactColumn(tableColumn);
      } else if (tableColumn.tag === 'opportunityDetails') {
        column = null;
      } else if (tableColumn.target_object === 'Opportunity' && tableColumn.target_field === 'requested_feedbacks') {
        column = this.getRequestedFeedbackColumn(tableColumn);
      } else {
        column = {
          column: tableColumn,
          customFieldType: CUSTOM_FIELD_TYPES.OPPORTUNITY,
          params: {
            onCellClicked: this.handleCellClicked,
          },
        };
      }
      if (column) {
        columns.push(column);
      }
      return columns;
    }, []);
    const checkColumn = this.getCheckColumn();
    return [checkColumn, ...allColumns, this.getActionColumn(), this.getSubmittedStatusColumn()];
  }

  refresh(opportunity, columns = null) {
    if (this.gridApi) {
      const { dynamicColumnIds } = this.state;
      if (opportunity) {
        let rowNode = null;
        this.gridApi.forEachNode((node) => {
          if (node.data && node.data.opportunity_id === opportunity.opportunity_id) {
            rowNode = node;
          }
        });
        if (rowNode) {
          this.gridApi.redrawRows({ rowNodes: [rowNode], columns });
        }
      } else {
        this.gridApi.refreshCells({ force: true, columns: [...dynamicColumnIds, 'ag-Grid-AutoColumn'] });
      }
    }
  }

  productColumnValueGetter(params) {
    const { winLoss, program } = this.props;
    if (!params || !params.data) {
      return null;
    }

    const products = program && program.initiatives && program.initiatives.products ? program.initiatives.products : [];

    const selectedOpp = winLoss[params.data.opportunity_id];
    const isSelected = selectedOpp !== undefined;
    const { tracking } = params.data;
    const loaded = tracking !== undefined;
    const allSubmitted = loaded && tracking && tracking.allSubmitted;
    const productIds = map(products, 'id');
    // const totalProductIds = params.data.line_items && params.data.line_items.length ? map(params.data.line_items, 'product_id') : productIds;

    let availableProductCount = 0;
    let selectedProductCount = 0;
    const totalProductCount = productIds.length;
    const selectedProductIds = selectedOpp ? intersection(productIds, selectedOpp.selected_product_ids) : [];
    const availableProductIds = difference(productIds, selectedProductIds);
    availableProductCount = availableProductIds.length;
    selectedProductCount = selectedProductIds.length;

    return {
      allSubmitted,
      loaded,
      availableProductCount,
      selectedProductCount,
      isSelected,
      totalProductCount,
      selectedOpportunity: selectedOpp,
    };
  }

  contactColumnValueGetter(params) {
    const { winLoss } = this.props;
    if (!params || !params.data) {
      return null;
    }
    const opportunity = params.data;
    const selectedOpportunity = winLoss[opportunity.opportunity_id];
    const isSelected = selectedOpportunity !== undefined;
    /*
    const availableContacts = getAvailableContacts(opportunity, selectedOpportunity ? selectedOpportunity.selected_contacts : opportunity.selected_contacts);
    const accountContactCount = availableContacts.account;
    const opportunityContactCount = availableContacts.opportunity;
    let availableContactCount = 0;
    let selectedContactCount = 0;
    const { tracking } = opportunity;
    // const canSubmitMore = tracking && !tracking.allSubmitted;
    const canSubmitMore = true;

    const loaded = tracking && tracking !== null && tracking !== undefined;
    let submittedContactIds = [];
    if (loaded) {
      submittedContactIds = tracking ? (tracking.submittedContactIds || []) : [];
    }
    if (selectedOpportunity && loaded && canSubmitMore) {
      if (selectedOpportunity && selectedOpportunity.selected_contacts) {
        const selectedContactIds = map(selectedOpportunity.selected_contacts, 'contact_id');
        selectedContactCount = selectedContactIds.length;
        const availableContactIds = difference(selectedContactIds, submittedContactIds);
        availableContactCount = availableContactIds.length;
      }
    }
    */
    const { tracking } = opportunity;
    const loaded = tracking && tracking !== null && tracking !== undefined;
    let submittedContactIds = [];
    if (loaded) {
      submittedContactIds = tracking ? (tracking.submittedContactIds || []) : [];
    }
    const canSubmitMore = true;
    const accountContactCount = 0;
    const opportunityContactCount = 0;
    const availableContactCount = 0;
    let selectedContactCount = 0;
    if (selectedOpportunity && loaded && canSubmitMore) {
      if (selectedOpportunity && selectedOpportunity.selected_contacts) {
        selectedContactCount = selectedOpportunity.selected_contacts.length;
      }
    }

    const submittedContactCount = submittedContactIds.length;
    return {
      canSubmitMore,
      loaded,
      isSelected,
      accountContactCount,
      opportunityContactCount,
      submittedContactCount,
      selectedContactCount,
      availableContactCount,
      selectedOpportunity,
    };
  }

  handleProductCellClicked(params) {
    const r = this.productColumnValueGetter(params);
    if (r && r.loaded && !r.allSubmitted) {
      this.props.requestshowEditProduct(r.selectedOpportunity);
    }
  }

  handleContactCellClicked(params) {
    const r = this.contactColumnValueGetter(params);
    if (r && r.loaded && r.canSubmitMore) {
      this.props.requestshowEditContacts(r.selectedOpportunity);
    }
  }

  showDispositionsDetail(opportunity) {
    this.props.requestShowDispositionsDetail(opportunity);
  }

  handleToggleAll() {
    const { disabled } = this.props;
    if (disabled) {
      return;
    }
    this.props.requestToggleAll()
      .then(() => { this.refresh(); });
  }

  handleCellClicked(params) {
    const { disabled } = this.props;
    if (!params || !params.data || disabled) {
      return;
    }
    const { winLoss } = this.props;
    const value = this.checkboxValueGetter(params);
    const opportunityId = params.data.opportunity_id;
    const selectedOpportunity = winLoss[opportunityId];
    const isSelected = selectedOpportunity !== null && selectedOpportunity !== undefined;
    const silent = true;
    const colId = params.column ? params.column.colId : null;
    if (value === NONE_SUBMIT || value === PARTIAL_SUBMIT) {
      if (isSelected) {
        if (!silent || colId === 'checkbox') {
          // do not deselect, let user deselect via the checkbox
          this.props.requestUnselectOpportunity(params.data)
            .then(() => { this.refresh(params.data); });
        }
      } else {
        if (!params.data.contactStatus) {
          this.refresh(params.data, ['action', 'checkbox']); // spinner
        }
        this.props.requestSelectOpportunity(params.data)
          .then(() => { this.refresh(params.data); });
      }
    }
  }

  handleRequestSelectOpportunity(opportunity) {
    if (!opportunity.contactStatus) {
      this.refresh(opportunity, ['action', 'checkbox']); // spinner
    }
    const p = this.props.requestSelectOpportunity(opportunity);
    p.then(() => {
      this.refresh(opportunity);
      const { winLoss } = this.props;
      const selectedOpportunity = winLoss[opportunity.opportunity_id];
      if (selectedOpportunity) {
        this.props.requestEditOpportunity(selectedOpportunity);
      }
    });
    return p;
  }

  handleRequestDeselectOpportunity(opportunity) {
    this.props.requestUnselectOpportunity(opportunity)
      .then(() => { this.refresh(opportunity); });
  }

  handleRequestShowLogs(loggedOpportunity) {
    this.setState({ loggedOpportunity });
  }

  handleFilterSelect(option) {
    this.setState({ status: option.value }, () => {
      if (this.gridApi) {
        const columnFilter = this.gridApi.getFilterInstance(STATUS_COLUMN_ID);
        if (columnFilter) {
          const { status } = this.state;
          if (status) {
            const v = status === 'submitted';
            columnFilter.selectNothing();
            columnFilter.selectValue(v);
          } else {
            columnFilter.selectEverything();
          }
          this.gridApi.onFilterChanged();
        }
      }
    });
  }

  handleOnColumnRowGroupChanged(event) {
    const { columns } = event;
    const closeDateColumn = find(columns, col => col.colDef && col.colDef.cellRendererParams && col.colDef.cellRendererParams.isCloseDate);
    this.setState({ groupingByCloseDate: closeDateColumn !== undefined });
  }

  checkboxValueGetter(params) {
    if (params && params.data) {
      const { tracking } = params.data;
      const loaded = tracking !== undefined;
      if (!loaded) {
        return null;
      }
      const submitted = loaded && tracking.submittedContactIds && tracking.submittedContactIds.length > 0;
      const canSubmitMore = tracking && !tracking.allSubmitted;
      if (canSubmitMore) {
        if (submitted) {
          return PARTIAL_SUBMIT;
        }
        return NONE_SUBMIT;
      }
      return ALL_SUBMIT;
    }
    return null; // export to excel with empty
  }

  renderStatusToggle() {
    const { status } = this.state;
    const items = FILTER_OPTIONS;

    const activeItem = find(items, { value: status }) || first(items);

    return (
      <span className="sub-header-with-controls">
        Show {' '}
        <Dropdown id="submit-status-dropdown">
          <Dropdown.Toggle bsStyle="link" bsSize="sm">
            {activeItem === undefined && <span>All Opportunities</span>}
            {activeItem !== undefined && <span>{activeItem.label}</span>}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {items.map((item) => {
              const isActive = activeItem !== undefined && activeItem.value === item.value;
              return (
                <MenuItem
                  eventKey={item}
                  active={isActive}
                  key={item.value}
                  onSelect={this.handleFilterSelect}
                >
                  {item.label}
                </MenuItem>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      </span>
    );
  }

  render() {
    const {
      opportunities,
      winLoss,
      program,
    } = this.props;
    // const { status } = this.state;

    const columnDefs = this.getColDefs();
    const sortedData = opportunities;
    return (
      <div>
        <LogModal
          object={this.state.loggedOpportunity}
          onClose={() => { this.setState({ loggedOpportunity: null }); }}
          program={program}
        />
        <GodTable
          id={this.props.tableName}
          columnDefs={columnDefs}
          rowData={sortedData}
          onGridReady={this.onGridReady}
          topControls={this.props.topControls}
          leftControls={this.renderStatusToggle()}
          context={{ winLoss }}
          frameworkComponents={{
            opportunityNameRenderer: OpportunityNameRenderer,
            accountNameRenderer: AccountNameRenderer,
            logRenderer: LogRenderer,
            saleRepsNameRenderer: SaleRepsNameRenderer,
            statusRenderer: StatusRenderer,
            checkboxRenderer: CheckboxRenderer,
            checkboxHeaderRenderer: CheckboxHeaderRenderer,
            actionRenderer: ActionRenderer,
            contactRenderer: ContactRenderer,
            warningRenderer: WarningRenderer,
            loadingRenderer: LoadingRenderer,
          }}
          columnTypes={{
            dateColumn: {
              filter: 'agDateColumnFilter',
              filterParams: {
                comparator: dateComparator,
              },
            },
          }}
          onColumnRowGroupChanged={this.handleOnColumnRowGroupChanged}
          getMainMenuItems={this.getMainMenuItems}
          enableFullScreen
          tableManageConfigs={{
            enableCustomMeta: true,
            validCustomMetaObjects: ['Opportunity'],
          }}
          getRowClass={this.getRowClass}
          getRowNodeId={data => data.opportunity_id}
          resourceType={GodTable.RESOURCE_TYPE.OPPORTUNITY}
        />
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state, ownProps) {
  return {
    tableColumns: getTablePreference(state, ownProps.tableName),
  };
}

OpportunityTable.propTypes = {
  opportunities: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  winLoss: PropTypes.shape({}).isRequired,
  program: PropTypes.shape({
    initiatives: PropTypes.shape({
      products: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
      })),
    }),
  }).isRequired,
  masterCheckboxStatus: PropTypes.string.isRequired,
  tableColumns: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string.isRequired,
    description: PropTypes.string,
    is_system: PropTypes.bool,
    is_visible: PropTypes.bool,
    position: PropTypes.number,
    width: PropTypes.number,
    tag: PropTypes.string,
    label: PropTypes.string,
    target_object: PropTypes.string,
    target_field: PropTypes.string,
  })),
  tableName: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  requestShowDispositionsDetail: PropTypes.func,
  requestshowEditProduct: PropTypes.func,
  requestEditOpportunity: PropTypes.func,
  requestshowEditContacts: PropTypes.func,
  editingOpportunity: PropTypes.shape({
    opportunity_id: PropTypes.string,
  }),
  requestSelectOpportunity: PropTypes.func,
  requestUnselectOpportunity: PropTypes.func,
  requestToggleAll: PropTypes.func,
  topControls: PropTypes.node,
  countSelected: PropTypes.number,
};
OpportunityTable.defaultProps = {
  tableColumns: [],
  disabled: false,
  requestShowDispositionsDetail: () => {},
  requestshowEditProduct: () => {},
  editingOpportunity: null,
  requestEditOpportunity: () => {},
  requestshowEditContacts: () => {},
  requestSelectOpportunity: () => {},
  requestUnselectOpportunity: () => {},
  requestToggleAll: () => {},
  topControls: null,
  countSelected: 0,
};
OpportunityTable.contextTypes = {
};

export default connect(mapStateToProps)(OpportunityTable);
